export default __webpack_public_path__ + "static/media/inventory2.19e28fb6.jpeg";